import { lazy } from 'react';

/** Загружает страницу шаблона уведомления */
export const NotificationTemplateDetailsPageAsync = lazy(
    () => import('./NotificationTemplateDetails/NotificationTemplateDetailsPage'),
);
